import apiClient from '../../../services/apiClient';
import { unwrapData, unwrapList } from './settingsResponse';

const resourcePath = {
  academicYears: 'academic-years',
  classes: 'class-levels',
  sections: 'sections',
  subjects: 'subjects',
};

const getPath = (schoolId, resource) =>
  `/schools/${schoolId}/academics/${resourcePath[resource]}`;

export const academicSettingsApi = {
  list: async (schoolId, resource) => {
    const response = await apiClient.get(`${getPath(schoolId, resource)}/`);
    return unwrapList(response.data);
  },

  create: async (schoolId, resource, payload) => {
    const response = await apiClient.post(
      `${getPath(schoolId, resource)}/create/`,
      payload,
    );
    return unwrapData(response.data);
  },

  retrieve: async (schoolId, resource, recordId) => {
    const response = await apiClient.get(
      `${getPath(schoolId, resource)}/${recordId}/`,
    );
    return unwrapData(response.data);
  },

  update: async (schoolId, resource, recordId, payload) => {
    const response = await apiClient.patch(
      `${getPath(schoolId, resource)}/${recordId}/update/`,
      payload,
    );
    return unwrapData(response.data);
  },

  updateStatus: async (schoolId, resource, recordId, status) => {
    const response = await apiClient.patch(
      `${getPath(schoolId, resource)}/${recordId}/status/`,
      { status },
    );
    return unwrapData(response.data);
  },
};
